module.exports = __webpack_public_path__ + "img/location-singapore-2-hover.b50aec6b.jpg";